/**
 * Convert seconds to milliseconds
 * @param value seconds
 * @returns value in milliseconds
 */
export function secondsToMilliseconds(value: number): number {
	return value * 1000;
}